var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-0",attrs:{"loading":_vm.loading,"text":"","outlined":"","small":"","color":_vm.color},on:{"click":_vm.download}},[_vm._v(" Download ")])}
var staticRenderFns = []

export { render, staticRenderFns }